import { Box, ListItem } from '@domain-group/suit-theme'
import usePortal from '@hooks/usePortal'
import usePortalOptions from '@hooks/usePortalOptions'
import { AgencyPortalModel } from '@models/types'
import PortalOptions from '../PortalOptions'

interface PortalProps {
  agencyPortal: AgencyPortalModel,
  selectedAgencyId: number,
}

const Portal = (props: PortalProps) => {
  const { agencyPortal, selectedAgencyId } = props
  const { portal, portal: { title } } = usePortal({ id: agencyPortal.portal_id })
  const { filteredPortalOptions } = usePortalOptions({
    filters: {
      // @ts-expect-error TS2339
      portal_id: portal?.id,
    },
  })

  if (!filteredPortalOptions.length) return null

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px dashed', fontSize: 'small', paddingX: 'large', marginTop: 'large',
      }}
      disableHover
      flexDirection="column"
      padding="large"
    >
      {/* Header Row */}
      <Box
        marginBottom="medium"
        width="100%"
      >
        <Box
          color="bodyFontLightColor"
          flex="1"
          fontSize="small"
          fontWeight="normal"
        >
          {title}
        </Box>

        <Box
          color="bodyFontLightColor"
          fontSize="xsmall"
          fontWeight="normal"
          textAlign="left"
          width="70px"
        >
          Enable
        </Box>

        <Box
          color="bodyFontLightColor"
          fontSize="xsmall"
          fontWeight="normal"
          textAlign="left"
          width="70px"
        >
          Default
        </Box>
      </Box>

      {filteredPortalOptions.map(portalOption => (
        <PortalOptions
          key={portalOption.id}
            // @ts-expect-error TS2322
          portal={portal}
          portalOption={portalOption}
          selectedAgencyId={selectedAgencyId}
        />
      ))}
    </ListItem>
  )
}

export default Portal
